
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";

// reactstrap components
import { Modal , Row} from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import MessageErrorScopeType from "../../app/models/errorMessageScope";
import MessageErrorAction from "../../app/models/errorMessageAction";


interface IProps {
  errorfileUploaded: string[],
  size?: string;
  isOpen: boolean;
  toggle: () => void;
}

const UploadedFileModal: React.FC<IProps> = ({ size,isOpen, toggle,errorfileUploaded}) => {

  const rootStore = useContext(RootStoreContext);
 const {messageErrorScope, messageErrorAction,ResetmessageErrorUploadedFiles}= rootStore.commonStore;

 useEffect(() => {


  return () => {
    ResetmessageErrorUploadedFiles();

  };
}, []);

  return (
  <Modal
  className="modal-dialog-centered"
  isOpen={isOpen}
  toggle={toggle}
  size={size ? size : "lg"}
>
  <div className="modal-header">
    <h1 className={`$modal-title `} id="exampleModalLabel">
      ATTENZIONE
    </h1>
    <button
      aria-label="Close"
      className="close"
      data-dismiss="modal"
      type="button"
      onClick={toggle}
    >
      <span aria-hidden={true}>×</span>
    </button>
  </div>
  <div className="modal-body">
  { errorfileUploaded && errorfileUploaded.length>0 && (<>
    <div>
    {errorfileUploaded.map((x: string, index: any) => (<>
      <li key={index} style={{color:"red"}}>{x}</li>
    </>))}
    </div>
    {(messageErrorScope!== MessageErrorScopeType.ODG && messageErrorScope!== MessageErrorScopeType.BOARD) ? (
      <>
   <div style={{marginTop:"3%"}}>
    Questi file in elenco non sono supportati dall'applicazione e quindi non sono stati inseriti.
    </div>
      </>
    ): 
    (<>
    <div style={{marginTop:"3%"}}>
      { messageErrorAction=== MessageErrorAction.INSERT && (<>
        I punti {messageErrorScope== MessageErrorScopeType.ODG  ? <>dell'ODG</> : (<>della BACHECA </>)} sono stati
       creati   correttamente ma i file in elenco non sono stati  aggiunti  in quanto non supportati dall'applicazione.
      </>)}
      {messageErrorAction===MessageErrorAction.UPDATE && 
        (<>Questi file in elenco non sono supportati dall'applicazione e quindi non sono stati inseriti. </>)}
    </div>
    
    </>)}
    </>)}
    
    </div>
</Modal>
  );
};

export default observer(UploadedFileModal);
